// vanilla/components/gallery/photo-grid.tsx
import React, { useState, useCallback, useRef } from "react";
import FullImageViewer from "./FullImageViewer";
import { useMasonryColumns } from "./use-masonry-columns";
import "./photo-grid.scss";

interface Photo {
  id: string;
  src_thumb: string;
  src_full: string;
  alt: string;
}

interface PhotosGridProps {
  photos: Photo[];
}

export function PhotoGrid({ photos }: PhotosGridProps) {
  const [activePhoto, setActivePhoto] = useState<Photo | null>(null);
  const containerRef = useRef<HTMLElement>(null);
  const { columns, registerImageDimensions, gap } = useMasonryColumns(
    photos,
    containerRef,
  );

  const handleClose = useCallback(() => {
    setActivePhoto(null);
  }, []);

  return (
    <div className="photos-grid">
      <section
        ref={containerRef}
        className="collections-container"
        style={{ gap }}
      >
        {columns.map((column, columnIndex) => (
          <div
            key={columnIndex}
            className="masonry-column"
            style={{ gap }}
          >
            {column.map((photo) => (
              <div
                key={photo.id}
                className="photo-grid-item"
                onClick={() => setActivePhoto(photo)}
              >
                <img
                  src={photo.src_thumb}
                  alt={photo.alt}
                  className="photo-grid-item__image"
                  loading="lazy"
                  onLoad={(event) => {
                    const img = event.currentTarget;
                    registerImageDimensions(
                      photo.id,
                      img.naturalWidth,
                      img.naturalHeight,
                    );
                  }}
                />
              </div>
            ))}
          </div>
        ))}
      </section>

      {/* Renderiza o visualizador apenas se houver uma foto ativa */}
      {activePhoto && (
        <FullImageViewer img={activePhoto} onClose={handleClose} />
      )}
    </div>
  );
}
